/** @format */
import isPropValid from '@emotion/is-prop-valid';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { ActiveFilter } from '../active-filter';
import { styles } from './active-filter-list.styles';
import { ActiveFilterListProps } from './types';

const StyledActiveFilterList = styled('ul').withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})`
    ${styles}
`;

export const ActiveFilterList: FunctionComponent<ActiveFilterListProps> = ({
    title,
    activeFilters,
    onRemove,
    'data-testid': dataTestId = 'criteria-list',
    ...otherProps
}: ActiveFilterListProps) => {
    return (
        <StyledActiveFilterList data-testid={dataTestId} {...otherProps}>
            {/* eslint-disable-next-line react/jsx-no-leaked-render -- Legacy code: do not use as an example. */}
            {title && <h3>{title}</h3>}
            {activeFilters.map((activeFilter, index) => (
                <ActiveFilter
                    // eslint-disable-next-line react/no-array-index-key -- Legacy code: do not use as an example.
                    key={index}
                    activeFilter={activeFilter}
                    className="criteria-box"
                    onRemove={onRemove}
                />
            ))}
        </StyledActiveFilterList>
    );
};
